import { RxCross1 } from 'react-icons/rx';
import SexIcons from '@/assets/Onboarding/SexIcons.svg';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog';

type SexeModaleProps = {
  show: boolean;
  onClose: () => void;
};

export const SexeModale = ({ show, onClose }: SexeModaleProps) => {
  return (
    <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className="flex flex-col flex-1 min-h-0 px-2 py-5">
          <DialogClose
            className="absolute top-3 right-2 h-8 rounded-lg p-1 mr-2 cursor-pointer focus:ring-0 focus:outline-hidden focus:border-transparent hover:bg-gray-100"
            onClick={onClose}
          >
            <RxCross1 className="h-5 w-5 text-gray-600 stroke-[0.2]" />
          </DialogClose>
          <div className="flex flex-col justify-start flex-1 min-h-0 overflow-y-auto">
            <img
              src={SexIcons}
              alt="Sexe"
              className="size-32 mb-6 mx-auto shrink-0"
            />
            <div className="flex flex-col gap-3">
              <p className="text-3.5xl font-medium leading-tight">
                Pourquoi préciser le sexe <br /> biologique ?
              </p>
              <p className="leading-5.5">
                Il existe bien sûr d&apos;autres identités de genre que « homme
                » ou « femme ». <br />
                <br />
                Aldebaran et votre médecin ont besoin de connaître votre sexe
                biologique pour adapter au mieux le questionnaire et
                l&apos;examen, car cela peut avoir un impact sur votre santé.
              </p>
            </div>
          </div>
          <DialogFooter>
            <Button variant="ctaPrimary" size="lg" onClick={onClose}>
              Compris
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};
